import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import React, { FC } from "react";
import { Dropdown } from "react-bootstrap";
import { DropDirection } from "react-bootstrap/esm/DropdownContext";

interface IProps {
  btnRevealClass?: string;
  drop?: DropDirection;
  children?: React.ReactNode;
  icon?: IconProp;
}

const CardDropdown: FC<IProps> = ({
  btnRevealClass = "",
  drop,
  children,
  icon = faEllipsisH,
}) => {
  return (
    <Dropdown
      className="font-sans-serif btn-reveal-trigger"
      align={"start"}
      drop={drop}
    >
      <Dropdown.Toggle
        variant="link"
        size="sm"
        data-boundary="viewport"
        className={classNames("text-600", {
          [btnRevealClass]: btnRevealClass,
          "btn-reveal": !btnRevealClass,
        })}
      >
        <FontAwesomeIcon icon={icon} className="fs--2" />
      </Dropdown.Toggle>
      <Dropdown.Menu className="border py-0">
        {children}
        {!children && (
          <div className="py-2">
            <Dropdown.Item>View</Dropdown.Item>
            <Dropdown.Item>Export</Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item className="text-danger">Remove</Dropdown.Item>
          </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CardDropdown;
